import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


const addDateParameters = (question) => {
  if (question?.hasDateParameters) {
    return {
      ...question,
      parameters: [
        {
          id: 'start_date', name: 'start_date', displayName: 'Start Date', type: 'DATE', index: -2, parameterType: 'RUN_TIME_PARAMETER',
        },
        {
          id: 'end_date', name: 'end_date', displayName: 'End Date', type: 'DATE', index: -1, parameterType: 'RUN_TIME_PARAMETER',
        },
        ...question.parameters,
      ],
    };
  }
  return question;
};

export const useFetchFlowNodeQuestionDetails = ({
  cleanRoomID,
  cleanRoomFlowID,
  nodeID,
  version,
  enabled = true,
}) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const {
    isLoading, isError, isSuccess, data, refetch, isRefetching,
  } = useQuery(
    ['Flow-Node-Question-Details', orgId, cleanRoomID, cleanRoomFlowID, nodeID],
    async () => axiosInstance.get(
      flow(orgId).getNodeQuestionDetails(cleanRoomID, cleanRoomFlowID, nodeID, version),
    ),
    {
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || 'Failed to fetch flow node question details';
        dispatch(showAlert({ message: errorMessage, type: 'error' }));
      },
      select: (response) => {
        if (response?.data?.questionDetails) {
          const processedQuestion = addDateParameters(response.data.questionDetails);

          // Ensure backward compatibility
          return {
            ...processedQuestion,
            computeCapacity: processedQuestion.computeCapacity
              || processedQuestion.defaultComputeCapacity
              || 'DEFAULT',
          };
        }
        return response?.data?.questionDetails;
      },
      refetchOnWindowFocus: false,
      enabled: !!(enabled && nodeID && cleanRoomID && cleanRoomFlowID && orgId),
    },
  );

  return {
    isLoading,
    isError,
    isSuccess,
    data,
    refetch,
    isRefetching,
  };
};
